import * as React from "react";

import { MetricsValueSender, MetricsValueSenderActions } from "./Internals/Metrics/MetricsValueSender";
import { createHocDisplayName } from "./TypingUtils";

export function withMetrics<P>(
    WrappedComponent: React.ComponentType<P & { metrics: MetricsValueSenderActions }>
): React.ComponentType<Omit<P, "metrics">> {
    function WithMetrics(inputProps: Omit<P, "metrics">): JSX.Element {
        return (
            // @ts-ignore Ну нехочет typescript работать с HOC-ами
            <MetricsValueSender>{metrics => <WrappedComponent {...inputProps} metrics={metrics} />}</MetricsValueSender>
        );
    }
    WithMetrics.displayName = createHocDisplayName(WrappedComponent, "Metrics");
    return WithMetrics;
}
